import { apis } from 'ui-common'
import endpoints from 'ui-common/lib/constants/endpoints.json'

export default {
  getEpworthProps: () => apis.$get(
    endpoints.epworthSleepinessScale.index,
    {
      params: {
        status: 1,
        order: 'sortby'
      }
    }
  )
}
